import { render, staticRenderFns } from "./msw-download-center.vue?vue&type=template&id=857d02b8&scoped=true&"
import script from "./msw-download-center.vue?vue&type=script&lang=tsx&"
export * from "./msw-download-center.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-download-center.vue?vue&type=style&index=0&id=857d02b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857d02b8",
  null
  
)

export default component.exports